import React, { Fragment, memo, useMemo } from 'react';
import { MobileAppButton, useIsMobileDimension } from '@beef/ui-kit';
import { useMobileOS } from '@beef/react';
import { PlatformContainer } from "../../../PlatformContainer";
import { PLATFORM_TYPE, STORE_TYPE, formatStoreButtons } from "./utils";
export var AppButtons = /*#__PURE__*/memo(function (_ref) {
  var appButtons = _ref.appButtons,
    _onClick = _ref.onClick;
  var stores = useMemo(function () {
    return formatStoreButtons(appButtons);
  }, [appButtons]);
  var storesTypes = Object.keys(stores);
  var isMobile = useIsMobileDimension();
  var mobileOS = useMobileOS();
  return /*#__PURE__*/React.createElement(PlatformContainer, {
    ignorePlatforms: !mobileOS,
    "data-t-id": "components-AppButtons"
  }, storesTypes.map(function (type, index) {
    var Platform = PLATFORM_TYPE[type] || Fragment;
    if (!stores[type]) return null;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      React.createElement(Platform, {
        key: type
      }, /*#__PURE__*/React.createElement(MobileAppButton, {
        href: stores[type],
        isFullWidth: isMobile,
        onClick: function onClick() {
          _onClick === null || _onClick === void 0 ? void 0 : _onClick(stores[type], index);
        },
        variant: STORE_TYPE[type],
        "data-t-id": "components-AppButtons"
      }))
    );
  }));
});